// extracted by mini-css-extract-plugin
var _1 = "SymbolItem_root__b59f7";
export { _1 as "root" }
